export const TitleStyle = ({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    fontSize: '22px !important',
    lineHeight: '28px !important'
  }
});
